import { Box, Typography } from "@material-ui/core";
import React from "react";
import styles from "./SafetySensors.module.scss";

interface IStatus {
  text?: string
  status: "ok" | "warning" | "error"
}

export const StatusIndicator = ({ text, status }: IStatus) => (

  <Box
    className={`${styles.statusIndicator} ${styles[`statusIndicator--${status}`]
      }`}
  >
    <span className={styles["statusIndicator__dot"]}></span>
    <Typography variant="h4" className={styles["statusIndicator__text"]}>
      {text}
    </Typography>
  </Box>

);
